import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {BroadcastsService} from "../../services/broadcasts.service";
import {Broadcast} from "../../model/broadcast/broadcast";
import {Player} from "../../model/broadcast/player";
import {UtilService} from "../../services/util.service";
import {UntypedFormControl, UntypedFormGroup, ReactiveFormsModule} from "@angular/forms";
import {Subscription} from "rxjs";
import {Game} from "../../model/broadcast/game";
import {BroadcastGamePair} from "../../model/broadcast-game-pair";
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatTabsModule} from "@angular/material/tabs";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatRadioModule} from "@angular/material/radio";
import {MatIconModule} from "@angular/material/icon";
import {NgIf, NgFor} from "@angular/common";
import {LowerThirdComponent} from "../../broadcast-layer-module/broadcast-layer/lower-third/lower-third.component";

@Component({
  selector: 'app-lower-third-dialog',
  templateUrl: './lower-third-dialog.component.html',
  styleUrls: ['./lower-third-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTabsModule,
    MatGridListModule,
    MatRadioModule,
    MatIconModule,
    ReactiveFormsModule,
    NgIf,
    NgFor,
    LowerThirdComponent
  ]
})
export class LowerThirdDialogComponent implements OnInit, OnDestroy {

  //selectedPerson: Player;
  homeRoster: Player[];
  awayRoster: Player[];
  otherRoster: Player[];
  custom: UntypedFormGroup;
  subs: Subscription[];
  broadcast: Broadcast;
  game: Game;

  constructor(
    public dialogRef: MatDialogRef<LowerThirdDialogComponent>,
    public broadcastsServise: BroadcastsService,
    public utilService: UtilService,
    @Inject(MAT_DIALOG_DATA) public data: BroadcastGamePair,
  ) {
    this.broadcast = this.data.broadcast;
    this.game = this.data.game;
  }

  ngOnInit(): void {
    this.subs = [];
    if (!this.broadcast.lowerThird) {
      this.broadcast.lowerThird = {batting: false, guid: "", name: "", info: "", teamGuid: null};
    }
    this.custom = new UntypedFormGroup({
      name: new UntypedFormControl(this.broadcast?.lowerThird?.name),
      info: new UntypedFormControl(this.broadcast?.lowerThird?.info),
      teamGuid: new UntypedFormControl(this.broadcast?.lowerThird?.teamGuid),
    });
    this.watchInputs();
    this.homeRoster = this.broadcast.fullRosters?.filter(p => p.teamGuid == this.broadcast.config.homeConfig.id);
    this.homeRoster.sort((a, b) => Number(a.number) - Number(b.number));
    this.awayRoster = this.broadcast.fullRosters?.filter(p => p.teamGuid == this.broadcast.config.awayConfig.id);
    this.awayRoster.sort((a, b) => Number(a.number) - Number(b.number));
    this.otherRoster = this.broadcast.fullRosters?.filter(p =>
      p.teamGuid != this.broadcast.config.homeConfig.id && p.teamGuid != this.broadcast.config.awayConfig.id);
  }

  private watchInputs() {
    this.subs.push(this.custom.controls.name.valueChanges.subscribe(value => {
      this.broadcast.lowerThird.name = value;
      this.broadcast.lowerThird.guid = null;
    }));
    this.subs.push(this.custom.controls.info.valueChanges.subscribe(value => {
      this.broadcast.lowerThird.info = value;
    }));
    this.subs.push(this.custom.controls.teamGuid.valueChanges.subscribe(value => {
      this.broadcast.lowerThird.teamGuid = value;
    }));
  }

  private unsubs() {
    this.subs.forEach(s => {
      s.unsubscribe();
    });
  }

  selectPerson(person: Player): void {
    this.broadcast.lowerThird = person;
    this.unsubs();
    this.custom.get('name').setValue(person.name);
    this.custom.get('info').setValue(person.info);
    this.custom.get('teamGuid').setValue(person.teamGuid);
    this.watchInputs();
  }

  close(): void {
    this.dialogRef.close();
  }

  update(): void {
    this.broadcastsServise.updateLowerThird(this.broadcast).then(() => {
      this.dialogRef.close('update');
    });
  }

  ngOnDestroy(): void {
    this.unsubs();
  }

}
